import SeoLandingPage from '../SeoLandingPage';

const config = {
  seoKey: 'dance',
  eyebrow: 'Dance Classes in Milton Keynes',
  h1: 'Dance Classes',
  h1Accent: 'in Milton Keynes',
  intro:
    'High-energy, technique-led dance training for ages 4–18 in Milton Keynes. From jazz and contemporary to street, ballet foundations and musical theatre choreography — every UPA student gets the choreography skills to shine on stage.',
  heroImage:
    'https://customer-assets.emergentagent.com/job_class-manager-84/artifacts/67s01etr_A7402917-Enhanced-NR-2-116.JPG',
  bullets: [
    {
      title: 'Multiple styles, one class',
      body: 'Jazz, contemporary, commercial, street and musical theatre choreography — every week.',
    },
    {
      title: 'Technique that travels',
      body: 'Ballet-based foundations so dancers can pick up choreography fast in any room.',
    },
    {
      title: 'Choreography & repertoire',
      body: 'New routines every term — set to West End scores, pop hits and original work.',
    },
    {
      title: 'Performance opportunities',
      body: 'Showcases, full productions and bootcamps so weekly work pays off on stage.',
    },
  ],
  whatYouLearn: [
    { title: 'Jazz', body: 'Classic and contemporary jazz — the spine of musical theatre dance.' },
    { title: 'Contemporary', body: 'Floorwork, release technique and storytelling through movement.' },
    { title: 'Street & Commercial', body: 'Sharp, rhythmic, viral choreography for confident young movers.' },
    { title: 'Ballet Foundations', body: 'Alignment, turnout, line and the discipline behind every dance style.' },
    { title: 'Musical Theatre Choreo', body: 'Triple-time, character steps and big-finish ensemble numbers.' },
    { title: 'Stage Performance', body: 'Spacing, eyelines, costume changes — everything live stage demands.' },
  ],
  ageGroups: [
    { ageRange: '4–6', label: 'Mini Stars' },
    { ageRange: '7–10', label: 'Juniors' },
    { ageRange: '11–14', label: 'Inters' },
    { ageRange: '15–18', label: 'Seniors' },
  ],
  relatedLinks: [
    { label: 'Musical Theatre Classes Milton Keynes', to: '/musical-theatre-classes-milton-keynes' },
    { label: 'Acting Classes Milton Keynes', to: '/acting-classes-milton-keynes' },
    { label: 'Singing Classes Milton Keynes', to: '/singing-classes-milton-keynes' },
    { label: 'Primatotterinas (Pre-school, 3–5)', to: '/primatotterinas' },
    { label: 'View the Class Timetable', to: '/schedule' },
    { label: 'Book a Free Trial', to: '/free-trial' },
  ],
};

const DanceMK = () => <SeoLandingPage config={config} />;
export default DanceMK;
